export default [
  {
    name: 'tfuel',
    baseAssetName: 'theta',
    displayName: 'Theta Fuel',
    ticker: 'TFUEL',
    units: { tfuelwei: 0, TFUEL: 18 },
    info: {
      description:
        'TFuel, the second token on the Theta blockchain, serves as both a gas token and a utility token for decentralized video and data delivery.',
      reddit: 'https://www.reddit.com/r/theta_network/',
      twitter: 'https://twitter.com/Theta_Network',
      website: 'https://www.thetatoken.org/',
      telegram: 'https://t.me/thetanetwork',
    },
    primaryColor: '#FF5E00',
    gradientColors: ['#FFA50D', '#FE5413'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
]
